export default __webpack_public_path__ + "static/media/assistantSound.d257afed.mp3";